// import React from "react";
// import { useForm } from "react-hook-form";
// import { Box, Typography } from "@mui/material";

// import Stockin from "./Stockin";
// import Stockout from "./Stockout";
// import { WSTabs } from "../../../Components/Tabs/WSTabs";

// const StockEntry = () => {
//   const { control, setValue } = useForm({
//     defaultValues: {
//       stockTab: 0, // 👈 default to Stock In
//     },
//   });

//   const tabs = [
//     {
//       label: "Stock In",
//       content: <Stockin />,
//     },
//     {
//       label: "Stock Out",
//       content: <Stockout />,
//     },
//   ];

//   return (
//     <Box sx={{ p: 2 }}>
//       {}
//       <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: 2 }}>
//         Stock Entry
//       </Typography>

//       {}
//       <WSTabs
//               name="stockTab"
//               control={control}
//               setValue={setValue}
//               tabs={tabs} id={""}      />
//     </Box>
//   );
// };

// export default StockEntry;



import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Typography } from "@mui/material";

import Stockin from "./Stockin";
import Stockout from "./Stockout";
import { WSTabs } from "../../../Components/Tabs/WSTabs";

import { useLocation, useNavigate } from "react-router-dom";

const StockEntry = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isStockinEdit = /^\/stockin\/.+/.test(location.pathname);
  const isStockinAdd = location.pathname === "/stockin";
  const isStockoutEdit = /^\/stockout\/.+/.test(location.pathname);
  const isStockoutAdd = location.pathname === "/stockout";

  // 👇 Decide tab based on URL
  const getDefaultTab = () => {
    if (location.pathname.includes("stockout")) return 1;
    return 0; // default Stock In
  };

  const { control, setValue } = useForm({
    defaultValues: {
      stockTab: getDefaultTab(),
    },
  });

   useEffect(() => {
    
  if (location.pathname.includes("stockout")) {
    setValue("stockTab", 1);
  } else {
    setValue("stockTab", 0);
  }
}, [location.pathname, setValue]);


  const tabs = [
    {
      label: "Stock In",
      content: <Stockin />,
    },
    {
      label: "Stock Out",
      content: <Stockout />,
    },
  ];

  return (
    <Box
      sx={{
        p: 2,
        ...(isStockinEdit && {
          "& #ws-tab-1": {
            pointerEvents: "none",
            opacity: 0.5,
            cursor: "not-allowed",
          },
        }),
        ...(isStockoutEdit && {
          "& #ws-tab-0": {
            pointerEvents: "none",
            opacity: 0.5,
            cursor: "not-allowed",
          },
        }),
      }}
    >
      <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: 2 }}>
        Stock Entry
      </Typography>

      <WSTabs
        name="stockTab"
        control={control}
        setValue={setValue}
        tabs={tabs}
        id=""
        onTabChange={(newValue) => {
          if (isStockinAdd && newValue === 1) {
            navigate("/stockentry/list", { state: { activeTab: 1 } });
          } else if (isStockoutAdd && newValue === 0) {
            navigate("/stockentry/list", { state: { activeTab: 0 } });
          }
        }}
      />
    </Box>
  );
};

export default StockEntry;